import Overview from './overview.vue';
import MobFull from '@rebuild/materials/shared/question/mobile/MobFullIndex.vue';
import MobDetail from '@rebuild/materials/shared/question/mobile/MobDetail.vue';

export const componentMap = {
	overview: Overview,
	'mob-full': MobFull,
	'mob-detail': MobDetail
}; 